export default "__VITE_ASSET__D5X3EW4V__"